export default __webpack_public_path__ + "static/media/radio-selected.2a79dc7f.svg";